<template>
  <v-card>
    <v-toolbar card color="error" dark>
      <v-toolbar-title class="body-2">RECHAZO</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close-rejected')" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <upload-btn @clicked="onFilePicked"></upload-btn>
            <div v-if="form.files == null" class="v-text-field__details">
              <div class="v-messages theme--light error--text">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">El archivo es requerido</div>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex lg12 sm12>
            <v-textarea
              :error-messages="errors.collect('comment')"
              data-vv-name="comment"
              label="Comentarios"
              required
              v-model="form.observations"
              v-validate="'required'"
            ></v-textarea>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn @click="handleSave" color="error">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UploadButton from './FileUpload'

export default {
  components: {
    'upload-btn': UploadButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    form: {
      invoiceId: '',
      observations: '',
      files: null,
    },
  }),
  created() {
    this.form.invoiceId = this.item.id
  },
  methods: {
    onFilePicked(files) {
      this.form.files = files
    },
    handleSave() {
      this.$validator.validateAll().then(result => {
        if (result && this.form.files) {
          this.$store.dispatch('transit/denied', this.form).then(() => {
            this.$emit('save-rejected')
          })
        }
      })
    },
  },
}
</script>
